import angular from 'angular';

angular.module('cloudX').directive('cxBoolSelect', [
  function() {
    return {
      restrict: 'E',
      require: '^ngModel',
      replace: true,
      scope: {
        trueValue: '=',
        falseValue: '=',
        defaultValue: '=?',
      },
      template:
        '<select class="form-control">' +
        '<option value="true">{{trueValue||(\'True\'|translate)}}</option>' +
        '<option value="false">{{falseValue||(\'False\'|translate)}}</option>' +
        '</select>',
      link: function(scope, element, attrs, ngModel) {
        if (!ngModel) return;
        ngModel.$parsers.push(function(value) {
          if (value === null) return !!scope.defaultValue || false;
          return value == 'true';
        });
        ngModel.$formatters.push(function(value) {
          if (typeof value === 'undefined' || value === null) {
            value = !!scope.defaultValue || false;
          }
          return '' + (!!value).toString();
        });
      },
    };
  },
]);
